<div
    style=" background-color: #F3F3F5;width: 100%; height: auto; display: flex; justify-content: flex-end; padding: 0; margin: 0;">
    <button class="close-button" mat-dialog-close>
        <img src="./assets/images/close-icon.svg">
    </button>
</div>


<mat-dialog-content class="box-share-content">
    <div class="main-box-title-32" style="margin-bottom: 25px;">
        <ng-container *ngIf="!isUpgradeWarning; else upgradeTitle">
            Confirm Renewal Cancellation
        </ng-container>

        <ng-template #upgradeTitle>
            Upgrade Plan
        </ng-template>
        </div>
    <div>
        <div
            class="main-box-title-18"
            *ngIf="isUpgradeWarning"
        >
           You currently have an active paid subscription. If you would like to change your subscription plan you first need to cancel your existing subscription. <br>Once cancelled and your subscription period has expired you will be able to select a new subscription plan.
        </div>

        <div
            class="main-box-title-18"
            *ngIf="canCancelRenewal"
        >
            Sorry to see you go! If you continue, your subscription renewal will be cancelled immediately.
            You will keep access to your plan until the end of the current billing period.
        </div>

        <div
            class="main-box-title-18"
            *ngIf="!isUpgradeWarning && isPaypalPayment"
        >
            This subscription cannot be cancelled from here because it was paid with PayPal. Please cancel it from your PayPal account.
        </div>

        <div
            class="main-box-title-18"
            *ngIf="!isUpgradeWarning && !canCancelRenewal && !isPaypalPayment"
        >
            We could not identify the payment method for this subscription. Please contact support to cancel your renewal.
        </div>
        <div style="margin-top: 40px;">
        </div>
    </div>

        <div class="box-button" >
        <button class="cancel-btn" mat-dialog-close [disabled]="isProcessing">
            <span class="main-box-title-16" style="font-weight: 600;">
            Go back
            </span>
        </button>

        <button
            class="analysis-button"
            (click)="confirmRemove()"
            *ngIf="canCancelRenewal"
            [disabled]="isProcessing"
        >
            <span>
            {{ isProcessing ? 'Processing...' : 'Cancel Renewal' }}
            </span>
        </button>
        </div>

    <div
        *ngIf="errorMsg"
        style="margin-top: 15px; color: #EE1A1A; text-align: center;"
        class="main-box-title-14"
        >
        {{ errorMsg }}
    </div>

</mat-dialog-content>
